var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('fixedToolbar',{attrs:{"right":0,"bottom":140,"scroll-container-selector":'.app-main'},on:{"contact":_vm.onContact,"item-click":_vm.onItemClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }